module.exports = __webpack_public_path__ + "static/img/ousaisi_icon.d8cf9ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/ousaisi_icon.png
// module id = yqXm
// module chunks = 1